import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, first, mergeMap } from 'rxjs/operators';
import { PublicTokensState } from '../store/auth/auth.reducer';
import { AuthFacade } from './../store/auth/auth.facade';

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authFacade: AuthFacade) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.has('no-token')) {
      const headers = req.headers.delete('no-token');

      return next.handle(req.clone({ headers }));
    }

    if (req.headers.has('has-token')) {
      const headers = req.headers.delete('has-token');

      return this.authFacade.user$.pipe(
        filter((u) => !!u),
        first(),
        mergeMap((user) => {
          let newHeaders = headers;
          if (!newHeaders.has('X-AUTH-TOKEN')) {
            newHeaders = newHeaders.set('X-AUTH-TOKEN', user!.authToken);
          }
          if (!newHeaders.has('X-TN-TOKEN')) {
            newHeaders = newHeaders.set('X-TN-TOKEN', user!.tnToken);
          }

          return next.handle(
            req.clone({
              headers: newHeaders,
            })
          );
        })
      );
    }

    return this.authFacade.publicTokens$.pipe(
      filter((pt) => !!pt),
      first(),
      mergeMap(({ authToken, tnToken }: PublicTokensState) => {
        if (
          req.url.includes('/icad') &&
          !req.url.includes('/perm') &&
          !req.url.includes('/django') &&
          !req.url.includes('consulta-geral')
        ) {
          const headers = req.headers.set(
            'Authorization',
            `Token ${authToken}`
          );

          return next.handle(
            req.clone({
              headers,
            })
          );
        }

        let headers = req.headers;
        if (!headers.has('X-AUTH-TOKEN')) {
          headers = headers.set('X-AUTH-TOKEN', authToken);
        }
        if (!headers.has('X-TN-TOKEN')) {
          headers = headers.set('X-TN-TOKEN', tnToken);
        }

        return next.handle(
          req.clone({
            headers,
          })
        );
      })
    );
  }
}
